import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { 
    AddCompetitionWrapper,
    AddedCompetitionWrapper,
    TrashIconWrapper,
    CompetitionLabel,
    AddCompetitionRow,
    AddedCompetitionLabel,
    AddedCompetitionId,
    CompetitionError,
    AddCompetitionButtonWrapper
} from '../../Sports/SportsForm/SportsFilters/SportsFilters.style';

export const AddCompetition = observer(() => {
    const { cmsState, websocketV2 } = useAppStateContext();
    const {
        activeFilter,
        filtersMap,
        handleAddCompetition,
        handleDeleteCompetition,
        competitionName,
        competitionIdStatus, competitionId, competitionIdModel
    } = cmsState.specialSportsState;

    const filterItem = activeFilter !== null ? filtersMap.get(activeFilter) ?? null : null;

    if (filterItem === null) {
        return null;
    }

    return (
        <AddCompetitionWrapper>
            <OldInput
                label='Competition id'
                status={competitionIdStatus}
                formInputState={competitionId}
                model={competitionIdModel}
            />

            {competitionName !== null ? (
                <AddCompetitionRow>
                    <CompetitionLabel>{competitionName}</CompetitionLabel>
                    <AddCompetitionButtonWrapper onClick={handleAddCompetition}>Add</AddCompetitionButtonWrapper>
                </AddCompetitionRow>
            ) : competitionId.value.length > 0 ? (
                <CompetitionError>Invalid competition</CompetitionError>
            ) : null}

            <div>
                <Label>Added competitions:</Label>
                {filterItem.competitionIds.map((elem) => {
                    const competitionModel = websocketV2.getCompetitionModel(elem);

                    if (competitionModel !== null && activeFilter !== null) {
                        return (
                            <AddedCompetitionWrapper key={elem}>
                                <AddedCompetitionId>{competitionModel.id}</AddedCompetitionId>
                                <AddedCompetitionLabel>{competitionModel.name}</AddedCompetitionLabel>
                                <TrashIconWrapper onClick={(): void => handleDeleteCompetition(activeFilter, competitionModel.id)}>X</TrashIconWrapper>
                            </AddedCompetitionWrapper>
                        );
                    }
                })}
            </div>

        </AddCompetitionWrapper>
    );
});

